export const homeConstants = {
  PRODUCTS_LIST_REQUEST: "PRODUCTS_LIST_REQUEST",
  PRODUCTS_LIST_SUCCESS: "PRODUCTS_LIST_SUCCESS",
  PRODUCTS_LIST_FAILURE: "PRODUCTS_LIST_FAILURE",

  TOP_TEN_PRODUCTS_REQUEST: "TOP_TEN_PRODUCTS_REQUEST",
  TOP_TEN_PRODUCTS_SUCCESS: "TOP_TEN_PRODUCTS_SUCCESS",
  TOP_TEN_PRODUCTS_FAILURE: "TOP_TEN_PRODUCTS_FAILURE",

  PRODUCTS_SEARCH_REQUEST: "PRODUCTS_SEARCH_REQUEST",
  PRODUCTS_SEARCH_SUCCESS: "PRODUCTS_SEARCH_SUCCESS",
  PRODUCTS_SEARCH_FAILURE: "PRODUCTS_SEARCH_FAILURE",

  PRODUCT_DETAILS_REQUEST: "PRODUCT_DETAILS_REQUEST",
  PRODUCT_DETAILS_SUCCESS: "PRODUCT_DETAILS_SUCCESS",
  PRODUCT_DETAILS_FAILURE: "PRODUCT_DETAILS_FAILURE",

  PRODUCT_INSURANCE_REQUEST: "PRODUCT_INSURANCE_REQUEST",
  PRODUCT_INSURANCE_SUCCESS: "PRODUCT_INSURANCE_SUCCESS",
  PRODUCT_INSURANCE_FAILURE: "PRODUCT_INSURANCE_FAILURE",
  PRODUCT_INSURANCE_RESET: "PRODUCT_INSURANCE_RESET",

  SET_CURRENT_LOCATION: "SET_CURRENT_LOCATION",
  ZIP_SEARCH_RESULTS_REQUEST: "ZIP_SEARCH_RESULTS_REQUEST",
  ZIP_SEARCH_RESULTS_SUCCESS: "ZIP_SEARCH_RESULTS_SUCCESS",
  ZIP_SEARCH_RESULTS_FAILURE: "ZIP_SEARCH_RESULTS_FAILURE",

  ZIP_USE_DEVICE_LOCATION_REQUEST: "ZIP_USE_DEVICE_LOCATION_REQUEST",
  ZIP_USE_DEVICE_LOCATION_SUCCESS: "ZIP_USE_DEVICE_LOCATION_SUCCESS",
  ZIP_USE_DEVICE_LOCATION_FAILURE: "ZIP_USE_DEVICE_LOCATION_FAILURE",

  INSURANCE_DETAILS_SEARCH_REQUEST: "INSURANCE_DETAILS_SEARCH_REQUEST",
  INSURANCE_DETAILS_SEARCH_REQUEST_SUCCESS:
    "INSURANCE_DETAILS_SEARCH_REQUEST_SUCCESS",
  INSURANCE_DETAILS_SEARCH_REQUEST_FAILURE:
    "INSURANCE_DETAILS_SEARCH_REQUEST_FAILURE",

  RETAIL_PRICE_REQUEST: "RETAIL_PRICE_REQUEST",
  RETAIL_PRICE_SUCCESS: "RETAIL_PRICE_SUCCESS",
  RETAIL_PRICE_FAILURE: "RETAIL_PRICE_FAILURE",
  RETAIL_PRICE_UPDATE: "RETAIL_PRICE_UPDATE",

  DISCOUNT_PRICE_REQUEST: "DISCOUNT_PRICE_REQUEST",
  DISCOUNT_PRICE_UPDATE: "DISCOUNT_PRICE_UPDATE",
  DISCOUNT_PRICE_SUCCESS: "DISCOUNT_PRICE_SUCCESS",
  DISCOUNT_PRICE_FAILURE: "DISCOUNT_PRICE_FAILURE",

  COPAY_PRICE_REQUEST: "COPAY_PRICE_REQUEST",
  COPAY_PRICE_SUCCESS: "COPAY_PRICE_SUCCESS",
  COPAY_PRICE_FAILURE: "COPAY_PRICE_FAILURE",
  COPAY_PRICE_RESET: "COPAY_PRICE_RESET",

  COUPON_PRICE_REQUEST: "COUPON_PRICE_REQUEST",
  COUPON_PRICE_UPDATE: "COUPON_PRICE_UPDATE",
  COUPON_PRICE_SUCCESS: "COUPON_PRICE_SUCCESS",
  COUPON_PRICE_FAILURE: "COUPON_PRICE_FAILURE",
  COUPON_PRICE_RESET: "COUPON_PRICE_RESET",
  COUPON_PRICE_LOWEST_UPDATE: "COUPON_PRICE_LOWEST_UPDATE",

  ALTERNATE_LIST_REQUEST: "ALTERNATE_LIST_REQUEST",
  ALTERNATE_LIST_SUCCESS: "ALTERNATE_LIST_SUCCESS",
  ALTERNATE_LIST_FAILURE: "ALTERNATE_LIST_FAILURE",

  BRAND_DETAILS_REQUEST: "BRAND_DETAILS_REQUEST",
  BRAND_DETAILS_SUCCESS: "BRAND_DETAILS_SUCCESS",
  BRAND_DETAILS_FAILURE: "BRAND_DETAILS_FAILURE",
  RESET_BRAND_DETAILS_DATA: "RESET_BRAND_DETAILS_DATA",

  BRAND_DETAILS_REQUEST_NEW: "BRAND_DETAILS_REQUEST_NEW",
  BRAND_DETAILS_SUCCESS_NEW: "BRAND_DETAILS_SUCCESS_NEW",
  BRAND_DETAILS_FAILURE_NEW: "BRAND_DETAILS_FAILURE_NEW",
  RESET_BRAND_DETAILS_DATA_NEW: "RESET_BRAND_DETAILS_DATA_NEW",

  GENERIC_LIST_REQUEST: "GENERIC_LIST_REQUEST",
  GENERIC_LIST_SUCCESS: "GENERIC_LIST_SUCCESS",
  GENERIC_LIST_FAILURE: "GENERIC_LIST_FAILURE",

  GENERIC_DETAILS_REQUEST: "GENERIC_DETAILS_REQUEST",
  GENERIC_DETAILS_SUCCESS: "GENERIC_DETAILS_SUCCESS",
  GENERIC_DETAILS_FAILURE: "GENERIC_DETAILS_FAILURE",

  RECENT_SEARCH_REQUEST: "RECENT_SEARCH_REQUEST",
  RECENT_SEARCH_SUCCESS: "RECENT_SEARCH_SUCCESS",
  RECENT_SEARCH_FAILURE: "RECENT_SEARCH_FAILURE",

  SIGN_IN_REQUEST: "SIGN_IN_REQUEST",
  SIGN_IN_SUCCESS: "SIGN_IN_SUCCESS",
  SIGN_IN_FAILURE: "SIGN_IN_FAILURE",

  SIGN_UP_REQUEST: "SIGN_UP_REQUEST",
  SIGN_UP_SUCCESS: "SIGN_UP_SUCCESS",
  SIGN_UP_FAILURE: "SIGN_UP_FAILURE",

  SIGN_OUT_REQUEST: "SIGN_OUT_REQUEST",
  SIGN_OUT_SUCCESS: "SIGN_OUT_SUCCESS",
  SIGN_OUT_FAILURE: "SIGN_OUT_FAILURE",

  FORGOT_PASSWORD_REQUEST: "FORGOT_PASSWORD_REQUEST",
  FORGOT_PASSWORD_SUCCESS: "FORGOT_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_FAILURE: "FORGOT_PASSWORD_FAILURE",

  CHANGE_PASSWORD_REQUEST: "CHANGE_PASSWORD_REQUEST",
  CHANGE_PASSWORD_SUCCESS: "CHANGE_PASSWORD_SUCCESS",
  CHANGE_PASSWORD_FAILURE: "CHANGE_PASSWORD_FAILURE",
  RESET_CHANGE_PASSWORD_DATA: "RESET_CHANGE_PASSWORD_DATA",

  MESSAGES_LIST_REQUEST: "MESSAGES_LIST_REQUEST",
  MESSAGES_LIST_SUCCESS: "MESSAGES_LIST_SUCCESS",
  MESSAGES_LIST_FAILURE: "MESSAGES_LIST_FAILURE",

  MESSAGES_COUNT_REQUEST: "MESSAGES_COUNT_REQUEST",
  MESSAGES_COUNT_SUCCESS: "MESSAGES_COUNT_SUCCESS",
  MESSAGES_COUNT_FAILURE: "MESSAGES_COUNT_FAILURE",

  MESSAGE_MARK_AS_READ_REQUEST: "MESSAGE_MARK_AS_READ_REQUEST",
  MESSAGE_MARK_AS_READ_SUCCESS: "MESSAGE_MARK_AS_READ_SUCCESS",
  MESSAGE_MARK_AS_READ_FAILURE: "MESSAGE_MARK_AS_READ_FAILURE",

  MESSAGE_DELETE_REQUEST: "MESSAGE_DELETE_REQUEST",
  MESSAGE_DELETE_SUCCESS: "MESSAGE_DELETE_SUCCESS",
  MESSAGE_DELETE_FAILURE: "MESSAGE_DELETE_FAILURE",

  MESSAGES_MARK_ALL_READ_REQUEST: "MESSAGES_MARK_ALL_READ_REQUEST",
  MESSAGES_MARK_ALL_READ_SUCCESS: "MESSAGES_MARK_ALL_READ_SUCCESS",
  MESSAGES_MARK_ALL_READ_FAILURE: "MESSAGES_MARK_ALL_READ_FAILURE",

  MESSAGES_DELETE_ALL_REQUEST: "MESSAGES_DELETE_ALL_REQUEST",
  MESSAGES_DELETE_ALL_SUCCESS: "MESSAGES_DELETE_ALL_SUCCESS",
  MESSAGES_DELETE_ALL_FAILURE: "MESSAGES_DELETE_ALL_FAILURE",

  MY_COUPONS_REQUEST: "MY_COUPONS_REQUEST",
  MY_COUPONS_SUCCESS: "MY_COUPONS_SUCCESS",
  MY_COUPONS_FAILURE: "MY_COUPONS_FAILURE",

  DELETE_COUPON_REQUEST: "DELETE_COUPON_REQUEST",
  DELETE_COUPON_SUCCESS: "DELETE_COUPON_SUCCESS",
  DELETE_COUPON_FAILURE: "DELETE_COUPON_FAILURE",

  GET_PROFILE_REQUEST: "GET_PROFILE_REQUEST",
  GET_PROFILE_SUCCESS: "GET_PROFILE_SUCCESS",
  GET_PROFILE_FAILURE: "GET_PROFILE_FAILURE",

  SAVE_PROFILE_REQUEST: "SAVE_PROFILE_REQUEST",
  SAVE_PROFILE_SUCCESS: "SAVE_PROFILE_SUCCESS",
  SAVE_PROFILE_FAILURE: "SAVE_PROFILE_FAILURE",

  RESET_SAVE_PROFILE: "RESET_SAVE_PROFILE",

  CONTACT_US_REQUEST: "CONTACT_US_REQUEST",
  CONTACT_US_SUCCESS: "CONTACT_US_SUCCESS",
  CONTACT_US_FAILURE: "CONTACT_US_FAILURE",

  CUVERD_SETTINGS_REQUEST: "CUVERD_SETTINGS_REQUEST",
  CUVERD_SETTINGS_SUCCESS: "CUVERD_SETTINGS_SUCCESS",
  CUVERD_SETTINGS_FAILURE: "CUVERD_SETTINGS_FAILURE",

  NOTIFICATIONS_REQUEST: "NOTIFICATIONS_REQUEST",
  NOTIFICATIONS_SUCCESS: "NOTIFICATIONS_SUCCESS",
  NOTIFICATIONS_FAILURE: "NOTIFICATIONS_FAILURE",

  VERIFY_FORGOT_PASSWORD_REQUEST: "VERIFY_FORGOT_PASSWORD_REQUEST",
  VERIFY_FORGOT_PASSWORD_SUCCESS: "VERIFY_FORGOT_PASSWORD_SUCCESS",
  VERIFY_FORGOT_PASSWORD_FAILURE: "VERIFY_FORGOT_PASSWORD_FAILURE",

  VERIFY_RESEND_PASSWORD_CHANGE_REQUEST:
    "VERIFY_RESEND_PASSWORD_CHANGE_REQUEST",
  VERIFY_RESEND_PASSWORD_CHANGE_SUCCESS:
    "VERIFY_RESEND_PASSWORD_CHANGE_SUCCESS",
  VERIFY_RESEND_PASSWORD_CHANGE_FAILURE:
    "VERIFY_RESEND_PASSWORD_CHANGE_FAILURE",

  VERIFY_PASSWORD_CHANGE_REQUEST: "VERIFY_PASSWORD_CHANGE_REQUEST",
  VERIFY_PASSWORD_CHANGE_SUCCESS: "VERIFY_PASSWORD_CHANGE_SUCCESS",
  VERIFY_PASSWORD_CHANGE_FAILURE: "VERIFY_PASSWORD_CHANGE_FAILURE",

  VERIFY_PHONE_NUMBER_CHANGE_REQUEST: "VERIFY_PHONE_NUMBER_CHANGE_REQUEST",
  VERIFY_PHONE_NUMBER_CHANGE_SUCCESS: "VERIFY_PHONE_NUMBER_CHANGE_SUCCESS",
  VERIFY_PHONE_NUMBER_CHANGE_FAILURE: "VERIFY_PHONE_NUMBER_CHANGE_FAILURE",

  CHANGE_EMAIL_REQUEST: "CHANGE_EMAIL_REQUEST",
  CHANGE_EMAIL_SUCCESS: "CHANGE_EMAIL_SUCCESS",
  CHANGE_EMAIL_FAILURE: "CHANGE_EMAIL_FAILURE",

  CHANGE_PHONE_NUMBER_REQUEST: "CHANGE_PHONE_NUMBER_REQUEST",
  CHANGE_PHONE_NUMBER_SUCCESS: "CHANGE_PHONE_NUMBER_SUCCESS",
  CHANGE_PHONE_NUMBER_FAILURE: "CHANGE_PHONE_NUMBER_FAILURE",

  VERIFY_EMAIL_CHANGE_REQUEST: "VERIFY_EMAIL_CHANGE_REQUEST",
  VERIFY_EMAIL_CHANGE_SUCCESS: "VERIFY_EMAIL_CHANGE_SUCCESS",
  VERIFY_EMAIL_CHANGE_FAILURE: "VERIFY_EMAIL_CHANGE_FAILURE",

  CLEAR_RECENT_REQUEST: "CLEAR_RECENT_REQUEST",
  CLEAR_RECENT_SUCCESS: "CLEAR_RECENT_SUCCESS",
  CLEAR_RECENT_FAILURE: "CLEAR_RECENT_FAILURE",

  ACCOUNT_RESEND_ATTEMPT_REQUEST: "ACCOUNT_RESEND_ATTEMPT_REQUEST",
  ACCOUNT_RESEND_ATTEMPT_SUCCESS: "ACCOUNT_RESEND_ATTEMPT_SUCCESS",
  ACCOUNT_RESEND_ATTEMPT_FAILURE: "ACCOUNT_RESEND_ATTEMPT_FAILURE",
  RESET_ACCOUNT_CHANGE_DATA: "RESET_ACCOUNT_CHANGE_DATA",

  GET_CONTENT_TYPE_REQUEST: "GET_CONTENT_TYPE_REQUEST",
  GET_CONTENT_TYPE_SUCCESS: "GET_CONTENT_TYPE_SUCCESS",
  GET_CONTENT_TYPE_FAILURE: "GET_CONTENT_TYPE_FAILURE",

  SELECTED_PRODUCT: "SELECTED_PRODUCT",
  SELECTED_INSURANCE: "SELECTED_INSURANCE",
  RESET_SELECTED_INSURANCE: "RESET_SELECTED_INSURANCE",
  SELECTED_DOSAGE: "SELECTED_DOSAGE",
  SELECTED_FORM: "SELECTED_FORM",
  SELECTED_QUANTITY: "SELECTED_QUANTITY",
  RESET_DATA: "RESET_DATA",
  RESET_GENERIC_DETAILS_DATA: "RESET_GENERIC_DETAILS_DATA",
  RESET_LOGIN_STATUS: "RESET_LOGIN_STATUS",

  LOGIN_FORGOT_PASSWORD_REQUEST: "LOGIN_FORGOT_PASSWORD_REQUEST",
  LOGIN_FORGOT_PASSWORD_SUCCESS: "LOGIN_FORGOT_PASSWORD_SUCCESS",
  LOGIN_FORGOT_PASSWORD_FAILURE: "LOGIN_FORGOT_PASSWORD_FAILURE",

  LOGIN_FORGOT_PASSWORD_RESEND_REQUEST: "LOGIN_FORGOT_PASSWORD_RESEND_REQUEST",
  LOGIN_FORGOT_PASSWORD_RESEND_SUCCESS: "LOGIN_FORGOT_PASSWORD_RESEND_SUCCESS",
  LOGIN_FORGOT_PASSWORD_RESEND_FAILURE: "LOGIN_FORGOT_PASSWORD_RESEND_FAILURE",
  LOGIN_FORGOT_PASSWORD_RESEND_RESET: "LOGIN_FORGOT_PASSWORD_RESEND_RESET",

  LOGIN_FORGOT_PASSWORD_VERIFY_REQUEST: "LOGIN_FORGOT_PASSWORD_VERIFY_REQUEST",
  LOGIN_FORGOT_PASSWORD_VERIFY_SUCCESS: "LOGIN_FORGOT_PASSWORD_VERIFY_SUCCESS",
  LOGIN_FORGOT_PASSWORD_VERIFY_FAILURE: "LOGIN_FORGOT_PASSWORD_VERIFY_FAILURE",

  RESET_LOGIN_FORGOT_PASSWORD_STATUS: "RESET_LOGIN_FORGOT_PASSWORD_STATUS",
  RESET_SIGN_UP_STATUS: "RESET_SIGN_UP_STATUS",
  RESET_SAVED_COUPON_INFO: "RESET_SAVED_COUPON_INFO",
  RESET_DELETE_COUPON_INFO: "RESET_DELETE_COUPON_INFO",

  SEARCH_RADIUS_REQUEST: "SEARCH_RADIUS_REQUEST",
  SEARCH_RADIUS_SUCCESS: "SEARCH_RADIUS_SUCCESS",
  SEARCH_RADIUS_FAILURE: "SEARCH_RADIUS_FAILURE",

  SAVE_COUPON_REQUEST: "SAVE_COUPON_REQUEST",
  SAVE_COUPON_SUCCESS: "SAVE_COUPON_SUCCESS",
  SAVE_COUPON_FAILURE: "SAVE_COUPON_FAILURE",

  REMINDER_TIME_ZONE_REQUEST: "REMINDER_TIME_ZONE_REQUEST",
  REMINDER_TIME_ZONE_SUCCESS: "REMINDER_TIME_ZONE_SUCCESS",
  REMINDER_TIME_ZONE_FAILURE: "REMINDER_TIME_ZONE_FAILURE",

  REFILL_SAVINGS_DATA_REQUEST: "REFILL_SAVINGS_DATA_REQUEST",
  REFILL_SAVINGS_DATA_SUCCESS: "REFILL_SAVINGS_DATA_SUCCESS",
  REFILL_SAVINGS_DATA_FAILURE: "REFILL_SAVINGS_DATA_FAILURE",

  REMINDER_DATES_REQUEST: "REMINDER_DATES_REQUEST",
  REMINDER_DATES_SUCCESS: "REMINDER_DATES_SUCCESS",
  REMINDER_DATES_FAILURE: "REMINDER_DATES_FAILURE",

  DOSE_REMINDER_DATA_REQUEST: "DOSE_REMINDER_DATA_REQUEST",
  DOSE_REMINDER_DATA_SUCCESS: "DOSE_REMINDER_DATA_SUCCESS",
  DOSE_REMINDER_DATA_FAILURE: "DOSE_REMINDER_DATA_FAILURE",

  RESET_DOSE_REMINDER_DATA: "RESET_DOSE_REMINDER_DATA",

  RESET_REFILL_SAVINGS_DATA: "RESET_REFILL_SAVINGS_DATA",

  SAVE_DOSE_REMINDER_REQUEST: "SAVE_DOSE_REMINDER_REQUEST",
  SAVE_DOSE_REMINDER_SUCCESS: "SAVE_DOSE_REMINDER_SUCCESS",
  SAVE_DOSE_REMINDER_FAILURE: "SAVE_DOSE_REMINDER_FAILURE",
  RESET_DOSE_REMINDER_INFO: "RESET_DOSE_REMINDER_INFO",

  SAVE_REFILL_REMINDER_REQUEST: "SAVE_REFILL_REMINDER_REQUEST",
  SAVE_REFILL_REMINDER_SUCCESS: "SAVE_REFILL_REMINDER_SUCCESS",
  SAVE_REFILL_REMINDER_FAILURE: "SAVE_REFILL_REMINDER_FAILURE",
  RESET_REFILL_REMINDER_INFO: "RESET_REFILL_REMINDER_INFO",

  SEND_EMAIL_MESSAGE_REQUEST: "SEND_EMAIL_MESSAGE_REQUEST",
  SEND_EMAIL_MESSAGE_SUCCESS: "SEND_EMAIL_MESSAGE_SUCCESS",
  SEND_EMAIL_MESSAGE_FAILURE: "SEND_EMAIL_MESSAGE_FAILURE",
  RESET_SEND_EMAIL_MESSAGE_INFO: "RESET_SEND_EMAIL_INFO",

  SEND_TEXT_MESSAGE_REQUEST: "SEND_TEXT_MESSAGE_REQUEST",
  SEND_TEXT_MESSAGE_SUCCESS: "SEND_TEXT_MESSAGE_SUCCESS",
  SEND_TEXT_MESSAGE_FAILURE: "SEND_TEXT_MESSAGE_FAILURE",
  RESET_SEND_TEXT_MESSAGE_INFO: "RESET_SEND_TEXT_MESSAGE_INFO",

  SEND_HCP_TEXT_MESSAGE_REQUEST: "SEND_HCP_TEXT_MESSAGE_REQUEST",
  SEND_HCP_TEXT_MESSAGE_SUCCESS: "SEND_HCP_TEXT_MESSAGE_SUCCESS",
  SEND_HCP_TEXT_MESSAGE_FAILURE: "SEND_HCP_TEXT_MESSAGE_FAILURE",
  RESET_SEND_HCP_TEXT_MESSAGE_INFO: "RESET_SEND_HCP_TEXT_MESSAGE_INFO",

  ALLOW_EMAIL_NOTIFICATIONS_REQUEST: "ALLOW_EMAIL_NOTIFICATIONS_REQUEST",
  ALLOW_EMAIL_NOTIFICATIONS_SUCCESS: "ALLOW_EMAIL_NOTIFICATIONS_SUCCESS",
  ALLOW_EMAIL_NOTIFICATIONS_FAILURE: "ALLOW_EMAIL_NOTIFICATIONS_FAILURE",

  DENY_EMAIL_NOTIFICATIONS_REQUEST: "DENY_EMAIL_NOTIFICATIONS_REQUEST",
  DENY_EMAIL_NOTIFICATIONS_SUCCESS: "DENY_EMAIL_NOTIFICATIONS_SUCCESS",
  DENY_EMAIL_NOTIFICATIONS_FAILURE: "DENY_EMAIL_NOTIFICATIONS_FAILURE",

  ALLOW_TEXT_NOTIFICATIONS_REQUEST: "ALLOW_TEXT_NOTIFICATIONS_REQUEST",
  ALLOW_TEXT_NOTIFICATIONS_SUCCESS: "ALLOW_TEXT_NOTIFICATIONS_SUCCESS",
  ALLOW_TEXT_NOTIFICATIONS_FAILURE: "ALLOW_TEXT_NOTIFICATIONS_FAILURE",

  VALIDATE_COUPON_REQUEST: "VALIDATE_COUPON_REQUEST",
  VALIDATE_COUPON_SUCCESS: "VALIDATE_COUPON_SUCCESS",
  VALIDATE_COUPON_FAILURE: "VALIDATE_COUPON_FAILURE",
  RESET_VALIDATE_COUPON: "RESET_VALIDATE_COUPON",

  DENY_TEXT_NOTIFICATIONS_REQUEST: "DENY_TEXT_NOTIFICATIONS_REQUEST",
  DENY_TEXT_NOTIFICATIONS_SUCCESS: "DENY_TEXT_NOTIFICATIONS_SUCCESS",
  DENY_TEXT_NOTIFICATIONS_FAILURE: "DENY_TEXT_NOTIFICATIONS_FAILURE",
  RESET_NOTIFICATIONS_REMINDER_INFO: "RESET_NOTIFICATIONS_REMINDER_INFO",
  SELECTED_COUPON_INFO: "SELECTED_COUPON_INFO",

  SAVE_USER_INSURANCE_REQUEST: "SAVE_USER_INSURANCE_REQUEST",
  SAVE_USER_INSURANCE_SUCCESS: "SAVE_USER_INSURANCE_SUCCESS",
  SAVE_USER_INSURANCE_FAILURE: "SAVE_USER_INSURANCE_FAILURE",

  INSURANCE_INFO_REQUEST: "INSURANCE_INFO_REQUEST",
  INSURANCE_INFO_SUCCESS: "INSURANCE_INFO_SUCCESS",
  INSURANCE_INFO_FAILURE: "INSURANCE_INFO_FAILURE",

  RESET_ZIP_SEARCH: "RESET_ZIP_SEARCH",
  SORT_BY_PRICE: "SORT_BY_PRICE",
  SELECTED_ALTERNATE_LIST: "SELECTED_ALTERNATE_LIST",
  SELECTED_BRANDED_DETAILS: "SELECTED_BRANDED_DETAILS",
  SELECTED_GENERIC_DETAILS: "SELECTED_GENERIC_DETAILS",

  PLAY_STORE_REQUEST: "PLAY_STORE_REQUEST",
  PLAY_STORE_SUCCESS: "PLAY_STORE_SUCCESS",
  PLAY_STORE_FAILURE: "PLAY_STORE_FAILURE",

  GET_PREFERRED_COMMUNICATIONS_REQUEST: "GET_PREFERRED_COMMUNICATIONS_REQUEST",
  GET_PREFERRED_COMMUNICATIONS_SUCCESS: "GET_PREFERRED_COMMUNICATIONS_SUCCESS",
  GET_PREFERRED_COMMUNICATIONS_FAILURE: "GET_PREFERRED_COMMUNICATIONS_FAILURE",

  SAVE_PREFERRED_COMMUNICATIONS_REQUEST:
    "SAVE_PREFERRED_COMMUNICATIONS_REQUEST",
  SAVE_PREFERRED_COMMUNICATIONS_SUCCESS:
    "SAVE_PREFERRED_COMMUNICATIONS_SUCCESS",
  SAVE_PREFERRED_COMMUNICATIONS_FAILURE:
    "SAVE_PREFERRED_COMMUNICATIONS_FAILURE",

  SAVE_ZIP_CODE_REQUEST: "SAVE_ZIP_CODE_REQUEST",
  SAVE_ZIP_CODE_SUCCESS: "SAVE_ZIP_CODE_SUCCESS",
  SAVE_ZIP_CODE_FAILURE: "SAVE_ZIP_CODE_FAILURE",

  GET_GTM_DATA_LAYER: "GET_GTM_DATA_LAYER",
  UPDATE_GTM_DATA_LAYER: "UPDATE_GTM_DATA_LAYER",

  GET_DEVICE_DETAILS_REQUEST: "GET_DEVICE_DETAILS_REQUEST",
  GET_DEVICE_DETAILS_SUCCESS: "GET_DEVICE_DETAILS_SUCCESS",
  GET_DEVICE_DETAILS_FAILURE: "GET_DEVICE_DETAILS_FAILURE",

  GET_APP_IDENTITY_REQUEST: "GET_APP_IDENTITY_REQUEST",
  GET_APP_IDENTITY_SUCCESS: "GET_APP_IDENTITY_SUCCESS",
  GET_APP_IDENTITY_FAILURE: "GET_APP_IDENTITY_FAILURE",
  RESET_APP_IDENTITY_REQUEST: "RESET_APP_IDENTITY_REQUEST",

  PHARMACY_GROUP_LIST_REQUEST: "PHARMACY_GROUP_LIST_REQUEST",
  PHARMACY_GROUP_LIST_SUCCESS: "PHARMACY_GROUP_LIST_SUCCESS",
  PHARMACY_GROUP_LIST_FAILURE: "PHARMACY_GROUP_LIST_FAILURE",

  PRESCRIPTION_API_REQUEST: "PRESCRIPTION_API_REQUEST",
  PRESCRIPTION_API_SUCCESS: "PRESCRIPTION_API_SUCCESS",
  PRESCRIPTION_API_FAILURE: "PRESCRIPTION_API_FAILURE",

  GET_FIREBASE_NOTIFICATION: "GET_FIREBASE_NOTIFICATION",
};
